/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PntSegmentAdOverlayResponseDTO } from "./PntSegmentAdOverlayResponseDTO";

export type PntSegmentsControllerGetSegmentAdOverlayByDatePathParams = {
    /**
     * @type string
    */
    slug: string;
};

export const PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum = {
    true: "true",
    false: "false"
} as const;

export type PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnumKey = (typeof PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum)[keyof typeof PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum];

export const PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum = {
    asc: "asc",
    desc: "desc"
} as const;

export type PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnumKey = (typeof PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum)[keyof typeof PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum];

export const PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum = {
    date: "date",
    brand: "brand",
    duration: "duration"
} as const;

export type PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnumKey = (typeof PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum)[keyof typeof PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum];

export type PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams = {
    /**
     * @description From date
     * @type string
    */
    from: string;
    /**
     * @description To date
     * @type string
    */
    to: string;
    /**
     * @description Default `false`. If set to true all results will be returned, including the ones that do not have a `image_b64`
     * @type string | undefined
    */
    withResults?: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnumKey;
    /**
     * @description Supports `asc` and `desc`
     * @type string | undefined
    */
    sortOrder?: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnumKey;
    /**
     * @description Supports sort by `date`, `brand` and `duration`
     * @type string | undefined
    */
    sortBy?: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnumKey;
};

export type PntSegmentsControllerGetSegmentAdOverlayByDate200 = PntSegmentAdOverlayResponseDTO[];

export type PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse = PntSegmentsControllerGetSegmentAdOverlayByDate200;

export type PntSegmentsControllerGetSegmentAdOverlayByDateQuery = {
    Response: PntSegmentsControllerGetSegmentAdOverlayByDate200;
    PathParams: PntSegmentsControllerGetSegmentAdOverlayByDatePathParams;
    QueryParams: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams;
    Errors: any;
};